import { render, staticRenderFns } from "./add-route-user.vue?vue&type=template&id=0026ae78&scoped=true&"
import script from "./add-route-user.vue?vue&type=script&lang=js&"
export * from "./add-route-user.vue?vue&type=script&lang=js&"
import style0 from "./add-route-user.vue?vue&type=style&index=0&id=0026ae78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0026ae78",
  null
  
)

export default component.exports